<template>
  <div class="sec-movielist-base">
    <div class="items">
      <div class="item" v-for="( item, index ) in items" :key="index" @click.stop="onItemsClick(index)">
        <span class="preloader"></span>
        <img class="item-pic"
             :src="getImageUrl(item)"
             @load="onImgLoadComplete(index, $event)"
             @error="onImgLoadError(index, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as type from '@/utvStore/store/mutation-types'
import {mapState} from 'vuex'
import item from "../../store/modules/item";

export default {
  name: "SecMovieList",
  data() {
    return {
      limitLen: 2,
      items: []
    }
  },
  props: {
    tagId: {
      type: String,
      default(){
        return ''
      }
    },
    itemsReceive: {
      type: Array,
      default(){
        return []
      }
    }
  },
  computed: {
    ...mapState({
      subscriptVideoData: states => states.item.subscVideoItems
    })
  },
  watch: {
    subscriptVideoData: {
      handler(newData) {
        for(const item of this.itemsReceive){
          for(const data of newData){
            if(item.videoId == data.subscript_store_product_id){
              this.items.push({...item, ...data})
            }
          }
        }
        //動画は3つ以上ある前提
        this.items.splice(this.limitLen)
        this.$forceUpdate()
      },
      deep: true
    }
  },
  mounted(){
    const viewItems = this.$el.querySelectorAll('.item')
    setTimeout(()=>{
      for(let item of viewItems) {
        if(!item.classList.contains('loaded')) {
          item.classList.add('error')
        }
      }
    }, 5000)
  },
  methods: {
    getImageUrl(items) {
      return !!items ? items.thumbnail : ''
    },
    onImgLoadComplete(tgtIdx, e){
      const par = e.target.parentElement
      if(par != null){
        par.classList.remove('error')
        par.classList.add('loaded')
      }
    },
    onImgLoadError(tgtIdx, e){
      const par = e.target.parentElement
      if(par != null){
        par.classList.add('error')
        par.classList.remove('loaded')
      }
    },
    onItemsClick(idx){
      console.log('idx[%s]をおしたよ', idx, this.items[idx])
      location.href=`/menu/${this.items[idx].id}`

    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.sec-movielist-base {
  $thumb_bg: $col_gray2;
  .items {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    padding-bottom: 6px;
    .item {
      //width: 32.3%; //３個用
      //padding-top: 19%;  //３個用
      width: 49%;
      padding-top: 28.82%;
      position: relative;
      background: $thumb_bg;
      pointer-events: auto;
      cursor: pointer;
      img, span {
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        &.preloader {
          z-index: 55;
          background: url('/static/img/common/loading.svg') no-repeat center center rgba(255,255,255,0.8);
          background-size: 40px 40px;
          opacity: 1;
          transition: opacity 200ms ease-out 0s;
        }
        &.item-pic {
          z-index: 50;
          object-fit: cover;
          opacity: 0;
          transition: opacity 300ms ease-out 0s;
        }
      }
      &::after {
        content: "NO IMAGE";
        display: none;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        position: absolute;
        font-size: 11px;
        color: $col_temp_key1;
        background: $col_lite_gradient;
        line-height: 1;
        z-index: 40;
      }

      &.loaded {
        span.preloader {
          opacity: 0;
        }
        img.item-pic {
          opacity: 1;
        }
        &::after {
          display: none;
        }
      }

      &.error {
        span.preloader {
          opacity: 0;
        }
        &::after {
          display: flex;
        }

      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecMovieList.vue